module.exports = __webpack_public_path__ + "media/images/ui__arrowLeftInactive--dark-0b3f6abf845f02c4dad914e110a602c7.png";